import backend from "../../../../../../server.js";
import { getClientFilterCodes } from "../../../../../../js/credentialsApi.js";
import { normalizeAnakatechGames } from "./anakatechGames.js";

let clientsRequest;
const gamesRequests = new Map();

function sessionClientId() {
  try {
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    return user?.c_id ?? user?.clientId ?? "";
  } catch {
    return "";
  }
}

export function loadAnakatechClients() {
  if (!clientsRequest) {
    clientsRequest = (async () => {
      const allowedCodes = await getClientFilterCodes();
      if (Array.isArray(allowedCodes) && !allowedCodes.length) {
        return { clients: [], allowedCodes };
      }

      const params = { page: 1, xpage: 300 };
      if (Array.isArray(allowedCodes)) params.codes = allowedCodes.join(",");

      const response = await backend.client.lists(params);
      const availableClients = response?.data?.list || [];
      const restrictedClientId = sessionClientId();
      const clients = restrictedClientId
        ? availableClients.filter(
            (client) => String(client?.id) === String(restrictedClientId),
          )
        : availableClients;

      return { clients, allowedCodes };
    })().catch((error) => {
      clientsRequest = null;
      throw error;
    });
  }
  return clientsRequest;
}

export function loadAnakatechGames(clientCode, currency) {
  const normalizedClientCode = String(clientCode ?? "").trim();
  const normalizedCurrency = String(currency ?? "").trim().toUpperCase();
  if (!normalizedClientCode || !normalizedCurrency) return Promise.resolve([]);

  const cacheKey = `${normalizedClientCode}|${normalizedCurrency}`;
  if (!gamesRequests.has(cacheKey)) {
    const request = backend.freespin
      .getGameIdsAnakatech(normalizedClientCode, normalizedCurrency)
      .then(normalizeAnakatechGames)
      .catch((error) => {
        gamesRequests.delete(cacheKey);
        throw error;
      });
    gamesRequests.set(cacheKey, request);
  }
  return gamesRequests.get(cacheKey);
}

export function clearAnakatechCatalogCache() {
  clientsRequest = null;
  gamesRequests.clear();
}
